/* eslint-disable @typescript-eslint/no-explicit-any */
const windowObj = window as any;

export const fbqAddScript = () => {
  if (windowObj.fbq) {
    return;
  }

  (function (f?: any, b?: any, e?: any, v?: any, n?: any, t?: any, s?: any) {
    if (f.fbq) {
      return;
    }

    n = f.fbq = function () {
      // eslint-disable-next-line prefer-rest-params, prefer-spread
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };

    if (!f._fbq) {
      f._fbq = n;
    }
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
};

export const fbqSetupTracking = (facebookPixelId: any) => {
  if (windowObj.fbq) {
    windowObj.fbq('init', facebookPixelId);
  }
};
